import React, { useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useAuth } from '../auth/AuthContext';

export function paymentDays(doc) {
  if (!doc.doc_date || !doc.bxdatascadenta) return '';
  const days = (Date.parse(String(doc.bxdatascadenta).slice(0,10)) - Date.parse(String(doc.doc_date).slice(0,10))) / 86400000;
  return Number.isFinite(days) ? Math.max(0, Math.round(days)) : '';
}

export default function InvoicePrintDetails({doc, setField, disabled}) {
  const details = doc.print_details || {};
  const auth = useAuth();
  const userName = auth?.user?.user_name || '';
  useEffect(() => {
    if (!doc.id && !doc.print_details?.prepared_by && userName) {
      setField('print_details', {...(doc.print_details || {}), prepared_by:userName});
    }
  }, [doc.id, userName]); // Initialize new invoices; subsequent edits stay manual.
  const change = (key, value) => setField('print_details', {...details, [key]: value});
  return <fieldset disabled={disabled} className="border rounded p-3 my-3">
    <legend className="float-none w-auto fs-6 px-2">Plată și date pentru tipărire</legend>
    <Row className="g-2">
      <Col md={3}><Form.Label>Modalitate de plată</Form.Label><Form.Select aria-label="Modalitate de plată" value={details.payment_method || 'OP'} onChange={e=>change('payment_method',e.target.value)}>
        {['OP','Numerar','Card','Altă variantă'].map(v=><option key={v}>{v}</option>)}
      </Form.Select></Col>
      {details.payment_method === 'Altă variantă' && <Col md={3}><Form.Label>Detalii plată</Form.Label><Form.Control value={details.payment_other || ''} maxLength={100} onChange={e=>change('payment_other',e.target.value)}/></Col>}
      <Col md={3}><Form.Label>Termen de plată (zile)</Form.Label><Form.Control aria-label="Termen de plată (zile)" type="number" min="0" step="1" value={paymentDays(doc)} onChange={e=>{
        if(e.target.value==='') return setField('bxdatascadenta','');
        const d = new Date(String(doc.doc_date).slice(0,10)+'T00:00:00Z');
        d.setUTCDate(d.getUTCDate()+Math.max(0,Math.trunc(Number(e.target.value))));
        if(!Number.isNaN(d.getTime())) setField('bxdatascadenta',d.toISOString().slice(0,10)+'T00:00:00');
      }}/></Col>
      <Col md={3}><Form.Label>Penalizări (% pe zi), opțional</Form.Label><Form.Control aria-label="Penalizări (% pe zi)" type="number" min="0" max="100" step="0.01" value={details.penalty_percent ?? ''} onChange={e=>change('penalty_percent',e.target.value===''?null:Number(e.target.value))}/></Col>
      {[
        ['prepared_by','Întocmit de'],['delegate_name','Nume delegat'],
        ['delegate_series','Serie BI/CI delegat'],['delegate_number','Număr BI/CI delegat'],
        ['transport','Mijloc de transport'],['registration','Număr de înmatriculare']
      ].map(([key,label])=><Col md={3} key={key}><Form.Label>{label}</Form.Label><Form.Control aria-label={label} maxLength={key==='prepared_by'||key==='delegate_name'?200:100} value={details[key] || ''} onChange={e=>change(key,e.target.value)}/></Col>)}
    </Row>
  </fieldset>;
}
